import { Currency, TariffPriceType } from 'src/app/base/models/models.swagger.generated';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TariffPricesFormType } from '../tariff-details-from-types';
import { TranslateModule } from '@ngx-translate/core';
import { TariffDetailsPricesTieredPricesGridComponent } from './tariff-details-prices-tiered-prices-grid/tariff-details-prices-tiered-prices-grid.component';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';

import { ButtonGroupComponent } from '../../../../../../base/shared/button-group/button-group.component';

@Component({
    selector: 'app-tariff-details-prices',
    templateUrl: './tariff-details-prices.component.html',
    styleUrls: ['./tariff-details-prices.component.scss'],
    imports: [ReactiveFormsModule, ButtonGroupComponent, NumericTextBoxModule, AppErrorMessagesComponent, TariffDetailsPricesTieredPricesGridComponent, TranslateModule]
})
export class TariffDetailsPricesComponent {

  @Input() priceFormGroup: FormGroup<TariffPricesFormType>;
  @Input() maxParkingDuration: number;

  public get priceType(): TariffPriceType {
    return this.priceFormGroup.controls.priceType.value;
  }

  public CurrencyEnum = Currency;
  public PriceTypeEnum = TariffPriceType;

  constructor() {
  }
}

